export default __webpack_public_path__ + "static/media/testScheduled.1b8e366e.svg";